import { defaultState } from './defaultState'
import { notificationsTypes } from '../../actions/notifications/notificationsTypes'

export default (state = defaultState, { type, payload }) => {

  switch (type) {

    case 'START_QUALITY_CHECK' :
      return { ...state, qualityCheckInProgress: true, qualityReport: null, qualityCheckFailed: false }
    case 'QUALITY_CHECK_DONE' :
      return { ...state, qualityCheckInProgress: false, qualityReport: payload, qualityCheckFailed: false }
    case 'QUALITY_CHECK_NETWORK_FAILED' :
    case 'QUALITY_CHECK_BANDWIDTH_FAILED' :
    return { ...state, qualityCheckInProgress: false, qualityReport: null, qualityCheckFailed: true }
    default: {

      return state

    }

  }

}
